import { NgModule } from '@angular/core';

import {
  UserComponent,
  UserChartsComponent,
  UserDetailsComponent,
  UserPrintersComponent,
  UserPrintersCreateModalComponent,
  UserPrintersEditModalComponent,
  UserRolesComponent,
  UsersComponent,
} from './components';
import { UserRoutingModule } from './user-routing.module';
import { TmsLibModule } from '../../tms-shared';

@NgModule({
  declarations: [
    UserComponent,
    UserChartsComponent,
    UserDetailsComponent,
    UserPrintersComponent,
    UserPrintersCreateModalComponent,
    UserPrintersEditModalComponent,
    UserRolesComponent,
    UsersComponent,
  ],
  imports: [TmsLibModule, UserRoutingModule],
})
export class UserModule {}
